import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { MyWorkScheduleComponent } from './schedule/index.component'
import { EmployeeBookingInvoiceComponent } from './employee-booking/invoice/index.component'
import { EmployeeContractShowComponent } from './employee-contract/show/show.component'
import { MyWorkIndexComponent } from './index/index.component'
import { SupervisorBookingIndex } from './supervisor-booking/index/index.component'
import { OperationsGuard } from '../operation/operations.guard'

const routes: Routes = [
  {
    path: '',
    canActivate: [OperationsGuard],
    component: MyWorkIndexComponent,

    children: [
      {
        path: '',
        component: MyWorkScheduleComponent,
        pathMatch: 'full'
      },
      {
        path: 'employee-contracts',
        component: EmployeeContractShowComponent
      },
      {
        path: 'supervisor-bookings',
        component: SupervisorBookingIndex
      },
      {
        path: 'invoices',
        component: EmployeeBookingInvoiceComponent
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyWorkRoutingModule {}
